<template>
  <div class="checkboxBtn">
    <el-checkbox-group @change="defaultChanges" v-model="defaul"  size="mini">
      <el-checkbox-button
        v-for="(item, index) in list"
        :label="item"
        :key="index"
       
        >{{ item }}</el-checkbox-button
      >
    </el-checkbox-group>
  </div>
</template>
<script>
export default {
  props: ["list", "default"],
  data() {
    return {
      defaul: "",
    };
  },
  watch:{
    default(e){
      this.defaul=e
    }
  },
  created() {
    this.defaul = this.default;
  },
  methods: {
    defaultChanges(e) {
      this.defaul=e
      this.$emit("defaulchanges", this.defaul);
    },
  },
};
</script>
<style lang="scss" scoped>
.el-checkbox-group {
  .el-checkbox-button {
    margin-right: 0.8rem;
  
    border-radius: 0.1rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Denominated/checkboxBtn.vue